import React from 'react';
import { PulseLoader } from 'react-spinners';
import { val } from 'utils/helper';

export default function LoadableSpinner() {
	const spinnerColor = val('primary');

	return (
		<div className='w-full flex items-center justify-center py-20'>
			<PulseLoader color={spinnerColor} size={5} />
		</div>
	);
}
